/* AUVYRON theme.js — cart drawer, countdown, sliders, UI */
(function () {
  'use strict';
  var A = window.AUVYRON || {};

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var f = A.moneyFormat || '${{amount}}';
    return f.replace('{{amount_no_decimals}}', Math.round(cents / 100)).replace('{{amount}}', v).replace('{{amount_with_comma_separator}}', v);
  }
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* Toast */
  var toastTimer;
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* Reveal on scroll */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { threshold: 0.1 }) : null;
  function initReveal() { $all('.rv').forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-visible'); }); }
  initReveal();

  /* Announcement rotation */
  var msgs = $all('[data-rotate-msg]');
  if (msgs.length > 1) {
    var mi = 0;
    setInterval(function () {
      msgs[mi].classList.remove('active');
      mi = (mi + 1) % msgs.length;
      msgs[mi].classList.add('active');
    }, 4000);
  }

  /* Mobile menu + search */
  var menu = $('[data-mobile-menu]');
  $all('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu && menu.classList.add('open'); document.body.style.overflow = 'hidden'; }); });
  $all('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { menu && menu.classList.remove('open'); document.body.style.overflow = ''; }); });
  var sBar = $('[data-search-bar]');
  $all('[data-search-toggle]').forEach(function (b) { b.addEventListener('click', function () { if (sBar) { sBar.classList.toggle('open'); var i = sBar.querySelector('input'); if (i) i.focus(); } }); });

  /* Cart drawer */
  var drawer = $('[data-cart-drawer]'), scrim = $('[data-cart-scrim]');
  function openCart() { if (drawer) drawer.classList.add('open'); if (scrim) scrim.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeCart() { if (drawer) drawer.classList.remove('open'); if (scrim) scrim.classList.remove('open'); document.body.style.overflow = ''; }
  $all('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  $all('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  if (scrim) scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); if (menu) menu.classList.remove('open'); document.body.style.overflow = ''; } });

  function renderCart(cart) {
    $all('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count ? 'grid' : 'none'; });
    var ct = $('[data-cart-count-text]'); if (ct) ct.textContent = cart.item_count;
    var wrap = $('[data-cart-items]'); if (!wrap) return;

    var threshold = 7500, barEl = $('[data-ship-bar]'), msgEl = $('[data-ship-msg]');
    if (barEl) barEl.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    if (msgEl) msgEl.textContent = cart.total_price >= threshold ? 'You unlocked FREE express shipping' : ('Add ' + money(threshold - cart.total_price) + ' more for FREE express shipping');

    if (!cart.items.length) {
      wrap.innerHTML = '<div class="cart-empty"><p style="font-family:var(--font-heading);font-weight:700;font-size:18px">Your bag is empty</p><p style="color:#71717a;font-size:14px">Add something you will love.</p></div>';
      var foot = $('[data-cart-foot]'); if (foot) foot.style.display = 'none';
      return;
    }
    var foot2 = $('[data-cart-foot]'); if (foot2) foot2.style.display = '';
    wrap.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      return '<div class="cart-line">' +
        (img ? '<img src="' + img + '" alt="">' : '') +
        '<div style="flex:1;min-width:0"><p class="t">' + it.product_title + '</p>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<p style="font-size:11.5px;color:#71717a;margin:2px 0 0">' + it.variant_title + '</p>' : '') +
        '<p style="font-family:var(--font-heading);font-weight:700;margin:5px 0 0">' + money(it.final_line_price) + '</p>' +
        '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:7px">' +
        '<span class="qty"><button data-cart-dec data-key="' + it.key + '">&minus;</button><b>' + it.quantity + '</b><button data-cart-inc data-key="' + it.key + '">+</button></span>' +
        '<button data-cart-remove data-key="' + it.key + '" style="color:#a1a1aa;font-size:12px;text-decoration:underline">Remove</button>' +
        '</div></div></div>';
    }).join('');
    var sub = $('[data-cart-subtotal]'), tot = $('[data-cart-total]');
    if (sub) sub.textContent = money(cart.total_price);
    if (tot) tot.textContent = money(cart.total_price);
    bindCartButtons();
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }
  function changeQty(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () { toast('Something went wrong'); });
  }
  function bindCartButtons() {
    $all('[data-cart-inc]').forEach(function (b) { b.onclick = function () { var line = b.closest('.cart-line'); var q = parseInt(line.querySelector('.qty b').textContent, 10) || 1; changeQty(b.dataset.key, q + 1); }; });
    $all('[data-cart-dec]').forEach(function (b) { b.onclick = function () { var line = b.closest('.cart-line'); var q = parseInt(line.querySelector('.qty b').textContent, 10) || 1; changeQty(b.dataset.key, q - 1); }; });
    $all('[data-cart-remove]').forEach(function (b) { b.onclick = function (e) { e.preventDefault(); changeQty(b.dataset.key, 0); }; });
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () { openCart(); toast('Added to bag — great choice'); })
      .catch(function () { toast('Could not add — please try again'); });
  }

  /* Quick add buttons */
  $all('[data-quick-add]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); addToCart(b.getAttribute('data-quick-add'), 1); });
  });

  /* Product form (AJAX with /cart fallback) */
  $all('.js-product-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var idEl = form.querySelector('[name="id"]');
      var qEl = form.querySelector('[name="quantity"]');
      if (idEl) addToCart(idEl.value, parseInt(qEl ? qEl.value : '1', 10) || 1);
    });
    var dec = $('[data-qty-dec]', form), inc = $('[data-qty-inc]', form), input = $('[data-qty-input]', form);
    if (dec) dec.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (inc) inc.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    var sel = $('[data-variant-select]', form);
    if (sel) sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var price = opt.getAttribute('data-price');
      var pEl = $('[data-pd-price]'); if (pEl && price) pEl.textContent = price;
      var bEl = $('[data-pd-btn-price]'); if (bEl && price) bEl.textContent = price;
      var mid = opt.getAttribute('data-media-id');
      if (mid) {
        var sl = document.querySelector('[data-pd-slide][data-media-id="' + mid + '"]');
        var tk = document.querySelector('[data-pd-track]');
        if (sl && tk) tk.scrollTo({ left: sl.offsetLeft, behavior: 'smooth' });
      }
    });
  });

  /* Product gallery slider: swipe / drag / arrows / dots / thumbs / zoom */
  $all('[data-pd-slider]').forEach(function (root) {
    var track = root.querySelector('[data-pd-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-pd-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pd-dot]'));
    var thumbsWrap = root.querySelector('[data-pd-thumbs]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pd-thumb-btn]'));
    var counter = root.querySelector('[data-pd-counter]');
    var hint = root.querySelector('[data-pd-hint]');
    var idx = 0, ticking = false, dragged = false;

    function clamp(n) { return Math.max(0, Math.min(slides.length - 1, n)); }
    function go(n, smooth) {
      idx = clamp(n);
      track.scrollTo({ left: idx * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      paint();
    }
    function paint() {
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      thumbs.forEach(function (t, i) {
        var on = i === idx;
        t.classList.toggle('active', on);
        if (on && thumbsWrap) {
          thumbsWrap.scrollTo({ left: t.offsetLeft - thumbsWrap.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
      });
      if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
      slides.forEach(function (s, i) {
        if (i !== idx) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
    }
    track.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () {
          idx = clamp(Math.round(track.scrollLeft / track.clientWidth));
          paint();
          if (hint) hint.classList.add('hide');
          ticking = false;
        });
      }
    }, { passive: true });

    var prev = root.querySelector('[data-pd-prev]'), next = root.querySelector('[data-pd-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1 < 0 ? slides.length - 1 : idx - 1); });
    if (next) next.addEventListener('click', function () { go((idx + 1) % slides.length); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-pd-dot'), 10)); }); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-pd-thumb-btn'), 10)); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go((idx + 1) % slides.length); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1 < 0 ? slides.length - 1 : idx - 1); }
    });

    /* Mouse drag to slide (desktop) */
    var down = false, startX = 0, startL = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; dragged = false; startX = e.clientX; startL = track.scrollLeft;
      track.classList.add('dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 6) dragged = true;
      track.scrollLeft = startL - dx;
    });
    function endDrag() { if (down) { down = false; track.classList.remove('dragging'); go(clamp(Math.round(track.scrollLeft / track.clientWidth)), false); setTimeout(function () { dragged = false; }, 50); } }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    /* Lightbox zoom */
    var lb = root.querySelector('[data-pd-lightbox]');
    var lbImg = root.querySelector('[data-lb-img]');
    var lbCounter = root.querySelector('[data-lb-counter]');
    var lbIdx = 0;
    function lbPaint() {
      var s = slides[lbIdx];
      if (!s || !lbImg) return;
      lbImg.src = s.getAttribute('data-full') || (s.querySelector('img') ? s.querySelector('img').src : '');
      if (lbCounter) lbCounter.textContent = (lbIdx + 1) + ' / ' + slides.length;
    }
    function lbGo(n) { lbIdx = (n + slides.length) % slides.length; lbPaint(); }
    function openLb(i) { if (!lb) return; lbIdx = i; lbPaint(); lb.classList.add('open'); lb.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function closeLb() { if (!lb) return; lb.classList.remove('open'); lb.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    slides.forEach(function (s, i) {
      s.addEventListener('click', function () { if (!dragged && s.getAttribute('data-media-type') === 'image') openLb(i); });
    });
    var zoomBtn = root.querySelector('[data-pd-zoom]');
    if (zoomBtn) zoomBtn.addEventListener('click', function () { if (slides[idx] && slides[idx].getAttribute('data-media-type') === 'image') openLb(idx); });
    if (lb) {
      var c = lb.querySelector('[data-lb-close]'), p = lb.querySelector('[data-lb-prev]'), n = lb.querySelector('[data-lb-next]');
      if (c) c.addEventListener('click', closeLb);
      if (p) p.addEventListener('click', function () { lbGo(lbIdx - 1); });
      if (n) n.addEventListener('click', function () { lbGo(lbIdx + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      var tx = 0;
      lb.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 40) lbGo(lbIdx + (dx < 0 ? 1 : -1));
      }, { passive: true });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('open')) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowRight') lbGo(lbIdx + 1);
        if (e.key === 'ArrowLeft') lbGo(lbIdx - 1);
      });
    }
    paint();
  });


  /* Wishlist (local) */
  var wish = [];
  try { wish = JSON.parse(localStorage.getItem('auvyron_wishlist') || '[]'); } catch (e) { wish = []; }
  $all('[data-wishlist]').forEach(function (b) {
    var id = b.getAttribute('data-wishlist');
    if (wish.indexOf(id) > -1) b.classList.add('active');
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var i = wish.indexOf(id);
      if (i > -1) { wish.splice(i, 1); b.classList.remove('active'); toast('Removed from wishlist'); }
      else { wish.push(id); b.classList.add('active'); toast('Saved to your wishlist'); }
      try { localStorage.setItem('auvyron_wishlist', JSON.stringify(wish)); } catch (err) {}
    });
  });

  /* Category chips → collection pages */
  $all('[data-scroll-collection]').forEach(function (chip) {
    chip.addEventListener('click', function () { window.location.href = chip.getAttribute('data-scroll-collection'); });
  });

  /* Deal countdown */
  $all('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target) || target < Date.now()) target = Date.now() + (11 * 3600 + 24 * 60 + 36) * 1000;
    var h = $('[data-cd-h]', el), m = $('[data-cd-m]', el), s = $('[data-cd-s]', el);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var d = Math.max(0, target - Date.now());
      if (h) h.textContent = pad(Math.floor(d / 3600000));
      if (m) m.textContent = pad(Math.floor((d % 3600000) / 60000));
      if (s) s.textContent = pad(Math.floor((d % 60000) / 1000));
    }
    tick(); setInterval(tick, 1000);
  });

  /* Testimonials slider */
  var track = $('[data-t-track]');
  if (track) {
    var idx = 0, total = track.children.length, dots = $all('[data-t-dot]');
    function go(n) {
      idx = (n + total) % total;
      track.style.transform = 'translateX(-' + idx * 100 + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    }
    var prev = $('[data-t-prev]'), next = $('[data-t-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-t-dot'), 10)); }); });
    setInterval(function () { go(idx + 1); }, 7000);
  }

  bindCartButtons();
})();
